<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <h1 class="display-3">Costos</h1>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 md3 order-xs2 order-md2 v-if="!estructuraOculta">
                <v-card>
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title>Estructura</v-toolbar-title>
                    </v-toolbar>
                    <v-list two-line dense v-if="!estructuraOculta">
                        <template v-for="s in secciones">

                            <v-list-tile @click.native="seleccionSecc(s.id)" ripple href="javascript:;">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ s.desig }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ (sel[s.id - 1]) ? sel[s.id - 1].desc : '' }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action v-if="sel[s.id -1]">
                                    <v-btn icon ripple>
                                        <v-icon class="green--text">done</v-icon>
                                    </v-btn>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-divider></v-divider>
                        </template>
                        <v-list-tile @click.native="copiaCodigo(codigo)">
                            <v-list-tile-content>
                                <v-list-tile-title>CODIGO DEL PRODUCTO</v-list-tile-title>
                                <v-list-tile-sub-title>{{ codigo }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>
                    </v-list>
                </v-card>
            </v-flex>
            <v-flex xs12 :md9="!estructuraOculta" order-xs1 order-md2>
                <v-card>
                    <v-toolbar color="primary" dark>
                        <v-toolbar-side-icon @click="estructuraOculta = !estructuraOculta"></v-toolbar-side-icon>
                        <v-toolbar-title>Características</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-text-field label="Búsqueda por código" solo clearable hide-details v-model="codigoBusq" @input="decodifica()"></v-text-field>
                        <v-slide-x-reverse-transition mode="out-in">
                            <v-btn flat icon @click="descarga" v-show="indexActivo === 7 ">
                                <v-icon>cloud_download</v-icon>
                            </v-btn>
                        </v-slide-x-reverse-transition>
                    </v-toolbar>
                    <v-progress-linear :indeterminate="indeterminado" :active="loading" v-show="loading" height="5"></v-progress-linear>
                    <v-list dense>
                        <v-slide-y-reverse-transition mode="in-out" group>
                            <template v-for="(c,index) in datos">
                                <v-list-tile :key="'tit' + index" @click.native="seleccion(c)" ripple href="javascript:;">
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ c.desc }}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-divider :key="'div' + index"></v-divider>
                            </template>
                        </v-slide-y-reverse-transition>
                    </v-list>
                    <v-card-actions v-if="indexActivo === 7 ">
                        <v-select :items="ubicaciones" v-model="d.ubicacion" label="Ubicación"></v-select>
                        <v-select :items="empresas" v-model="d.empresa" label="Empresa"></v-select>
                        <v-spacer></v-spacer>
                        <v-btn flat class="green--text darken-1" @click.native="traeEstructura()" :loading="loading">Datos</v-btn>
                    </v-card-actions>
                </v-card>
                <v-data-table
                        v-if="mostrarTabla"
                        :headers="headers"
                        :items="items"
                        hide-actions
                        class="elevation-1 animated fadeIn"
                >
                    <template slot="items" slot-scope="props">
                        <td>
                            <span v-if="props.item.prod_id">({{ props.item.prod_id }})</span>
                            <b>{{ props.item.title }}</b></td>
                        <td class="text-xs-right">{{ props.item.cant | moneda }}</td>
                        <td class="text-xs-right">{{ props.item.um }}</td>
                        <td class="text-xs-right">{{ props.item.precio | moneda(2) }}</td>
                        <td class="text-xs-right">{{ props.item.incid | moneda }}</td>
                        <td class="text-xs-right">{{ props.item.scrap | moneda }}</td>
                        <td class="text-xs-right"><b>{{ props.item.total | moneda(2)}}</b></td>
                        <td class="text-xs-right">
                            <v-edit-dialog :return-value.sync="props.item.porcent" lazy style="width: 100%"
                            >
                                <span style="width: 100%">{{ (props.item.porcent)?props.item.porcent : 0 }}</span>
                                <v-text-field
                                        slot="input"
                                        v-model="props.item.porcent"
                                        label="Editar"
                                        single-line
                                        type="number"
                                        hint="Presione Enter para guardar"
                                >
                                </v-text-field>
                            </v-edit-dialog>
                        </td>
                        <td class="text-xs-center">{{ props.item.tipo_costo | tipoCosto }}</td>
                        <td>
                            <v-menu open-on-hover left top offset-y v-if="props.item.actualizado !== true && props.item.actualizado > 0">
                                <v-icon color="orange" slot="activator">warning</v-icon>
                                <v-card dark>
                                    <v-card-text>El costo fue actualizado hace {{ props.item.actualizado}} dias</v-card-text>
                                </v-card>
                            </v-menu>
                            <v-menu open-on-hover left top offset-y v-if="props.item.total === 0">
                                <v-icon color="red" slot="activator">info</v-icon>
                                <v-card dark>
                                    <v-card-text>No se encontró costo para este item</v-card-text>
                                </v-card>
                            </v-menu>
                        </td>
                    </template>
                    <template slot="footer" v-if="totalCosto">
                        <td colspan="6" class="text-xs-right">
                            <h3>Total: </h3>
                        </td>
                        <td class="text-xs-right">
                            <h3>{{ totalCosto | moneda(2)}}</h3>
                        </td>
                        <td class="text-xs-right">
                            <h3>{{ porcentTotal | moneda(2)}}</h3>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import filterMoneda from '../../filters/moneda';
    import mixinConfig from '../../mixins/config';
    import {mapActions} from 'vuex';
    import saveAs from 'file-saver';

    export default {
        filters: {
            tipoCosto(v) {
                if (v === 'LP') {
                    return 'Lista de precios'
                } else if (v === 'UE') {
                    return 'Última entrada'
                } else {
                    return '';
                }
            },
            moneda: filterMoneda
        },
        mixins: [mixinConfig],
        data() {
            return {
                estructuraOculta: false,
                mostrarTabla: false,
                loading: false,
                indeterminado: true,
                codigos: [],
                codigo: '',
                codigoBusq: '',
                secciones: [],
                indexActivo: 1,
                sel: [],
                totalCosto: '',
                headers: [
                    {text: 'Producto', value: 'title', align: 'center'},
                    {text: 'Cant', value: 'cant', align: 'center'},
                    {text: 'UM', value: 'um', align: 'center'},
                    {text: 'Precio Unit', value: 'precio', align: 'center'},
                    {text: 'Incid (USD/M2)', value: 'incid', align: 'center'},
                    {text: 'Scrap', value: 'scrap', align: 'center'},
                    {text: 'Total', value: 'total', align: 'center'},
                    {text: '% Variac.', value: '', align: 'center'},
                    {text: 'Tipo de Costo', value: 'tipo_costo', align: 'center'}
                ],
                items: [],
                ubicaciones: [
                    {text: 'Mendoza', value: 'M'},
                    {text: 'Buenos Aires', value: 'B'},
                ],
                empresas: [
                    {text: 'Friolatina', value: 1},
                    {text: 'Acerolatina', value: 3},
                ],
                d: {
                    ubicacion: 'M',
                    empresa: 3
                },
                editDialog: {},
                costoOtros: 0
            }
        },
        computed: {
            'seccionActiva'() {
                return (this.secciones[this.indexActivo]) ? this.secciones[this.indexActivo].desig : ''
            },
            datos() {
                if (this.indexActivo === 1) {
                    return this.codigos[this.indexActivo]
                }

                if (this.indexActivo === 7) {
                    return false;
                }
                return this.codigos[this.indexActivo][this.codigo]
            },
            porcentTotal() {
                let total = this.items.reduce((a, b) => {
                    let total = 0;
                    if (b.porcent && b.porcent !== '0' && b.porcent !== 0) {
                        let precioNuevo = parseFloat(b.precio) + ((parseFloat(b.porcent) * parseFloat(b.precio)) / 100);
                        let incid = precioNuevo * parseFloat(b.cant);
                        let totScrap = (incid > 0) ? (parseFloat(b.scrapBase) / 100) * incid : 0;
                        total = incid + totScrap;
                    } else if (b.key === 'IIBB') {// no lo tomo porque es sobre el total
                        total = 0;
                    } else {
                        total = parseFloat(b.total)
                    }
                    return total == null ? a : a + total;
                }, 0);
                return (total * (this.costoOtros / 100)) + total;
            }
        },
        mounted() {
            this.traeDatos();

        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            decodifica() {
                let val = '';
                let codigo = this.codigoBusq;
                if (!this.codigoBusq) {
                    this.indexActivo = 1;
                    this.sel = [];
                    return false;
                }
                if (this.indexActivo === 1) {
                    this.codigo = '';
                    this.sel = [];
                    val = codigo.substring(0, 2)
                } else if (this.indexActivo === 2) {
                    val = codigo.substring(2, 6);
                } else if (this.indexActivo === 3) {
                    val = codigo.substring(6, 10);
                } else if (this.indexActivo === 4) {
                    val = codigo.substring(10, 12);
                }
                else if (this.indexActivo === 5) {
                    val = codigo.substring(12, 13);
                }
                else if (this.indexActivo === 6) {
                    val = codigo.substring(13, 16);
                }
                if (this.indexActivo === 1) {
                    if (this.codigos[this.indexActivo][val]) {
                        this.seleccion(this.codigos[this.indexActivo][val])
                    } else {
                        return false;
                    }
                } else if (this.indexActivo !== 7 && this.codigos[this.indexActivo][this.codigo] && this.codigos[this.indexActivo][this.codigo][val]) {
                    this.seleccion(this.codigos[this.indexActivo][this.codigo][val]);
                } else {
                    return false;
                }
                if (this.indexActivo !== 7) {
                    this.decodifica();
                }
            },
            seleccion(indx) {
                if (this.indexActivo === 7) {
                    return false
                }
                this.indexActivo++;
                this.sel.push(indx);
                this.codigoSet();
                this.resetValores();
            },
            seleccionSecc(secc) {
                if (secc < this.indexActivo) {
                    let limite = secc - 1;
                    this.sel = this.sel.filter((itm, indx) => {
                        return indx < limite;
                    })
                }
                this.codigoSet();
                this.indexActivo = secc;
                this.resetValores();
            },
            codigoSet() {
                this.codigo = this.sel.map(function (elem) {
                    return elem.cod;
                }).join('');
            },
            traeDatos() {
                this.loading = true;
                this.$http.post('indicadores/costo/codigos')
                    .then(r => {
                        this.codigos = r.data.codigos;
                        this.secciones = r.data.secciones;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    })
            },
            traeConfig() {
                this.configGet({nom: 'costoOtros'}, r => {
                    this.costoOtros = r;
                }, err => console.error(err))
            },
            traeEstructura() {
                this.indeterminado = true;
                this.loading = true;
                this.$http.post('indicadores/costo/estructura', {sel: this.sel, d: this.d, codigo: this.codigo})
                    .then(r => {
                        this.loading = false;
                        if (r.data.tipo && r.data.tipo === 2) {
                            this.msjShow({txt: r.data.txt, tipo: r.data.tipo});
                            return false;
                        }
                        this.items = r.data.d.children;
                        this.totalCosto = r.data.totalCosto;
                        this.mostrarTabla = true;
                        this.traeConfig();
                    }, err => {
                        alert(err);
                        this.loading = false;
                    })
            },
            resetValores() {
                this.mostrarTabla = false;
                this.totalCosto = ''
            },
            copiaCodigo(codigo) {
                this.$copyText(codigo)
                    .then(r => {
                        this.msjShow({tipo: 'success', txt: 'Datos copiados al portapapeles',});
                        console.log(r)
                    }, err => {
                        console.log(err)
                    })
            },
            descarga() {
                this.indeterminado = true;
                this.loading = true;
                this.$http({
                    method: 'post',
                    url: 'indicadores/costo/excel-producto',
                    data: {sel: this.sel, d: this.d, codigo: this.codigo},
                    headers: {'Content-Type': 'application/json', 'Accept': 'application/vnd.ms-excel'},
                    responseType: "blob"
                })
                    .then((response) => {
                        saveAs(response.data, 'costos.xlsx');
                        this.loading = false;
                    })
                    .catch((error) => {
                        alert(error);
                        this.loading = false;
                    });
            }
        }
    }
</script>
<style>
    table.v-datatable.v-table tbody td,
    table.v-datatable.v-table tfoot td,
    table.v-datatable.v-table thead th {
        padding: 0;
        border-left: 1px solid rgba(0, 0, 0, .12);
        border-right: 1px solid rgba(0, 0, 0, .12);
    }

    div.v-menu__activator a {
        width: 100% !important;
    }

    .progreso {
        position: absolute !important;
        margin: 0;
        bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/costo.vue